<template>
  <div class="black-friday" v-if="isBlackFridayActive">
    <div class="black-friday__promotions" v-if="!userHasSubscription">
      <PlanRowItemBlackFriday
        v-for="(bundle, index) in filteredBundles"
        :key="bundle.id"
        :bundle="bundle"
        :index="index"
        class="black-friday__bundle-individuals-item"
      />
    </div>
    <div class="black-friday__certifications"><CertificationsBundleList /></div>
    <BFSmallPrint />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { updateCart, utmParamsUtils } from '@/helpers/mixins'
import PlanRowItemBlackFriday from '@/components/plan-item-card/PlanRowItemBlackFriday.vue'
import CertificationsBundleList from '@/components/shop-sections/CertificationsBundleList.vue'
import BFSmallPrint from '@/components/flow/small-prints/BFSmallPrint.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'BlackFriday',
  mixins: [updateCart, utmParamsUtils],
  components: {
    PlanRowItemBlackFriday,
    CertificationsBundleList,
    BFSmallPrint,
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      availableProductBundles: state => state.products.availableProductBundles,
    }),
    ...mapGetters({
      isBlackFridayActive: 'app/isBlackFridayActive',
      isBusinessUser: 'business/isBusinessUser',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    filteredBundles() {
      const {
        BLACK_FRIDAY_PRODUCT_BUNDLES: {
          INE_BLACK_FRIDAY_BUNDLE_ONE,
          INE_BLACK_FRIDAY_BUNDLE_TWO,
          INE_BLACK_FRIDAY_BUNDLE_THREE,
        },
      } = CONSTANTS
      return this.availableProductBundles.filter(bundle =>
        [
          INE_BLACK_FRIDAY_BUNDLE_ONE,
          INE_BLACK_FRIDAY_BUNDLE_TWO,
          INE_BLACK_FRIDAY_BUNDLE_THREE,
        ].includes(bundle.slug)
      )
    },
  },
  created() {
    this.clearCart()
    if (!this.isBlackFridayActive || this.isBusinessUser) {
      this.$router.push({ name: 'shop' })
    }
  },
}
</script>
<style lang="scss" scoped>
.black-friday {
  color: var(--white);
  background-color: var(--dark-brighter);
  font-family: var(--font-regular);
  padding: 50px 20px 0 20px;
  display: flex;
  flex-flow: column;
  @include tablet {
    padding: 160px 0 0 0;
  }
  @include desktop {
    background-color: unset;
    padding: 160px 0 0 0;
    width: 1120px;
    margin: auto;
    margin-top: 30px;
    position: relative;
  }
  &__promotions {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 20px;
    align-self: stretch;
    flex-wrap: wrap;
    margin-bottom: 60px;
    @include tablet {
      align-items: flex-start;
      gap: 20px;
      align-self: stretch;
    }
  }
  &__certifications {
    margin-bottom: 60px;
  }
}
</style>
